import { useState, createContext } from 'react';

export const TabberContext = createContext(null);

export function TabberProvider({ children, ...props }) {
	//Dialog global state
	const [tabberData, setTabberData] = useState({
		tabs: [],
		selected: 0,
	});

	return (
		<TabberContext.Provider value={{ tabberData, setTabberData }} {...props}>
			{children}
		</TabberContext.Provider>
	);
}
